import styled from 'styled-components';
import { px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationStartStage = styled.div`
  .arrow-link {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${px2rem('15px')};

    ${mq('l')} {
      gap: ${px2rem('20px')};
    }

    .arrow-link__title {
      font-size: ${px2rem('20px')};

      ${mq('l')} {
        font-size: ${px2rem('24px')};
      }
    }

    .arrow-link__icon {
      background: black;
      color: white;
      height: ${px2rem('44px')};
      width: ${px2rem('44px')};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      svg {
        height: ${px2rem('20px')};
        width: ${px2rem('20px')};
      }
      ${mq('l')} {
        height: ${px2rem('76px')};
        width: ${px2rem('76px')};

        svg {
          height: ${px2rem('30px')};
          width: ${px2rem('30px')};
        }
      }
    }
  }
`;

export default StyledEducationStartStage;
